import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { HistoricalCustomerAddressModalComponent } from './historical-customer-address-modal.component';
import { HistoricalCustomerAddressComponent } from './historical-customer-address.component';

@NgModule({
    declarations: [
        HistoricalCustomerAddressComponent,
        HistoricalCustomerAddressModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        CommonModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        HistoricalCustomerAddressComponent,
        HistoricalCustomerAddressModalComponent
    ]
})

export class HistoricalCustomerAddressModule {}
